import {
  PageLayout,
  PageLayoutProps,
} from '../../components/PageLayout/PageLayout'
import { createWidget } from '../widget-utils'

export type PageLayoutWidgetProps = PageLayoutProps & {
  isLoading?: boolean
}

export const PageLayoutWidget = ({
  isLoading,
  ...props
}: PageLayoutWidgetProps) => <PageLayout {...props} />

export const PageLayoutWidgetDefinition = createWidget(PageLayoutWidget, {
  type: 'PageLayout',
  slots: ['headerSlot', 'sidebarSlot'],
  internalLoading: true,
})
